import { redirect, type ClientLoaderFunctionArgs, type MetaFunction } from 'react-router';
import DailyChallengeStateMachine from '../../src/pages/DailyChallengeStateMachine';
import { canonicalizeBoardInviteSearchParams } from '../../src/lib/boardInviteParams';
import { getDailyChallengeMetadata } from '../../src/constants/pageMetadata';
import StructuredData from '../../src/components/StructuredData/StructuredData';
import { getCanonicalUrl } from '../../src/lib/utils/url';
import { getDailyChallengeSchemas } from '../../src/pages/consumerSeoSchemas';
import { xpTrackerRouteHandle } from '../../src/routes';

export const handle = xpTrackerRouteHandle;

export const meta: MetaFunction = () => {
  const metadata = getDailyChallengeMetadata();

  return [
    { title: metadata.title },
    { name: 'description', content: metadata.description },
    { tagName: 'link', rel: 'canonical', href: getCanonicalUrl('/daily') },
  ];
};

export function clientLoader({ request }: ClientLoaderFunctionArgs) {
  const requestUrl = new URL(request.url);
  if (!canonicalizeBoardInviteSearchParams(requestUrl.searchParams)) {
    return null;
  }

  return redirect(`${requestUrl.pathname}${requestUrl.search}`);
}

export { default as HydrateFallback } from '../../src/pages/DailyRouteHydrateFallback';

export default function DailyRoute() {
  return (
    <>
      <StructuredData data={getDailyChallengeSchemas(getDailyChallengeMetadata().description)} />
      <DailyChallengeStateMachine />
    </>
  );
}
